import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=2421897d&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=2421897d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2421897d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2421897d')) {
      api.createRecord('2421897d', component.options)
    } else {
      api.reload('2421897d', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=2421897d&scoped=true", function () {
      api.rerender('2421897d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/medicaid/certification/Main.vue"
export default component.exports